var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#382a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "383b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#383b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69BEE7",
    fillRule: "evenodd",
    d: "M0 7.465h22v8.533H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6BD34",
    fillRule: "evenodd",
    d: "M8.38 4.266h5.239v1.066L10.999 6.4 8.382 5.332z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406421",
    fillRule: "evenodd",
    d: "M13.619 9.065c0-1.472-1.173-2.667-2.62-2.667-1.445 0-2.618 1.195-2.618 2.667S9.554 11.732 11 11.732s2.619-1.195 2.619-2.667m-2.62 1.6c.868 0 1.572-.955 1.572-2.133 0-1.179-.704-2.134-1.571-2.134s-1.572.955-1.572 2.134.704 2.133 1.572 2.133",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5B852",
    d: "M11 9.598c.29 0 .524-.477.524-1.066S11.289 7.465 11 7.465s-.524.477-.524 1.067c0 .589.235 1.066.524 1.066"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "382a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagSm = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagSm);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";